export default __webpack_public_path__ + "static/media/bus_c4.94f6594e.svg";